<template>
  <footer class="roomie-footer">
    <div class="w-full flex flex-col justify-center items-center">
      <div class="w-full roomie-footer__top max-w-screen-xl">
        <div class="roomie-footer__container mx-auto justify-between items-center">
          <div class="roomie-footer__logo-v2">
            <RoomieIcon custom-styles="block text-pine-600 w-[15rem] h-34">
              <LaHausLogoV2 />
            </RoomieIcon>
          </div>
          <div class="roomie-footer__logo-v1">
            <LaHausLogo />
          </div>
          <RoomieActionMenu
            :items="countries"
            :default-choice="selectedCountry"
            class="roomie-action-menu-countries"
            @toggle-action="toggleCountry" />
        </div>
      </div>

      <div class="w-full roomie-footer__center max-w-screen-xl">
        <div class="roomie-footer__container mx-auto w-full justify-between">
          <div class="roomie-footer__content">
            <div class="roomie-footer__contact">
              <div class="roomie-footer__contact-dropdown">
                <span class="roomie-footer__contact-title">Contacto en:</span>
                <RoomieActionMenu
                  :items="selectedCountry.cities"
                  :default-choice="selectedCity"
                  @toggle-action="toggleCity" />
              </div>
              <ul class="roomie-footer__contact-menu">
                <li>
                  <div>
                    <PinIcon class="roomie-icon text-brand-800 pointer-events-none" />
                  </div>
                  <a
                    :href="`http://maps.google.com/?q=${selectedCity.address}`"
                    target="_blank"
                    rel="noopener noreferrer">
                    {{ selectedCity.address }}
                  </a>
                </li>
                <li>
                  <EmailIcon class="roomie-icon text-brand-800 pointer-events-none" />
                  <a href="mailto:servicioalcliente@lahaus.com">servicioalcliente@lahaus.com</a>
                </li>
                <li v-if="selectedCity.phone">
                  <PhoneIcon class="roomie-icon text-brand-800 pointer-events-none" />
                  <a
                    :href="`tel:+${selectedCity.phone}`"
                    target="_blank"
                    rel="noopener noreferrer">
                    +{{ selectedCity.phone }}
                  </a>
                </li>
                <li v-if="selectedCity.availability">
                  <p class="roomie-footer__description-content">
                    {{ selectedCity.availability }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="roomie-footer__navigation">
            <div
              v-for="navLink in selectedCountry.footerNavigation"
              :key="navLink.id"
              class="roomie-footer__navigation-row">
              <h4 class="roomie-footer__navigation-title">
                {{ navLink.title }}
              </h4>
              <ul>
                <li
                  v-for="element in navLink.items"
                  :key="element.id">
                  <a
                    :href="element.link"
                    rel="noopener noreferrer">
                    {{ element.description }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="roomie-footer__bottom">
      <div class="roomie-footer__container mx-auto justify-between items-center">
        <div class="roomie-footer__social-icons">
          <RoomieNavigationButton
            v-for="socialNetwork in socialNetworks"
            :id="socialNetwork.name"
            :key="socialNetwork.id"
            variant="dark"
            :aria-label="socialNetwork.name"
            @click="redirectTo(socialNetwork.link)">
            <YoutubeIcon v-if="socialNetwork.name === 'youtube'" />
            <TwitterIcon v-if="socialNetwork.name === 'twitter'" />
            <TiktokIcon v-if="socialNetwork.name === 'tiktok'" />
            <InstagramIcon v-if="socialNetwork.name === 'instagram'" />
            <LinkedinIcon v-if="socialNetwork.name === 'linkedin'" />
            <FacebookIcon v-if="socialNetwork.name === 'facebook'" />
          </RoomieNavigationButton>
        </div>
        <div class="roomie-footer__terms">
          <p class="roomie-footer__terms-copyright">
            © {{ getCurrentYear() }} {{ copyrightText }}
          </p>
          <ul class="roomie-footer__bottom-links">
            <li
              v-for="item in selectedCountry.footerTerms"
              :key="item.id">
              <a
                class="roomie-footer__bottom-link"
                :href="item.link"
                rel="noopener noreferrer">
                {{ item.description }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import RoomieActionMenu from '../RoomieActionMenu/index.vue'
import RoomieNavigationButton from '../RoomieNavigationButton/index.vue'
import PinIcon from '../../assets/icons/pin.svg'
import EmailIcon from '../../assets/icons/email.svg'
import LaHausLogo from '../../assets/icons/lahaus-logo.svg'
import TwitterIcon from '../../assets/icons/twitter-filled.svg'
import TiktokIcon from '../../assets/icons/tiktok-filled.svg'
import InstagramIcon from '../../assets/icons/instagram-filled.svg'
import LinkedinIcon from '../../assets/icons/linkedin-filled.svg'
import FacebookIcon from '../../assets/icons/facebook-filled.svg'
import PhoneIcon from '../../assets/icons/phone.svg'
import LaHausLogoV2 from '../../assets/icons/v2/la-haus.svg'
import YoutubeIcon from '../../assets/icons/youtube-filled.svg'
import RoomieIcon from '../RoomieIcon/index.vue'

export default {
  name: 'RoomieFooter',
  components: {
    RoomieIcon,
    RoomieActionMenu,
    RoomieNavigationButton,
    PhoneIcon,
    PinIcon,
    EmailIcon,
    LaHausLogo,
    TwitterIcon,
    TiktokIcon,
    InstagramIcon,
    LinkedinIcon,
    FacebookIcon,
    YoutubeIcon,
    LaHausLogoV2
  },
  props: {
    copyrightText: {
      type: String,
      default: ''
    },
    countries: {
      type: Array,
      required: true
    },
    socialNetworks: {
      type: Array,
      required: true
    },
    applicationsLinks: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      selectedCountry: this.countries[0],
      selectedCity: this.countries[0].cities[0]
    }
  },
  methods: {
    getCurrentYear() {
      const today = new Date
      return today.getFullYear()
    },
    toggleCountry(value) {
      this.selectedCountry = value
      this.selectedCity = this.selectedCountry.cities[0]
    },
    toggleCity(city) {
      this.selectedCity = city
    },
    redirectTo(link) {
      let a = document.createElement('a')
      a.href = link
      a.setAttribute('target', '_blank')
      a.click()
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
